export default "__VITE_ASSET__41599810__"